import { proxy } from 'valtio'

export type InspectPin = uui.domain.ui.map.InspectPin | undefined

type InspectPinAtom = {
  pin: InspectPin
}

export const inspectPin = proxy<InspectPinAtom>({ pin: undefined })
